export default {
  'user.login.title': '销售登录',
  'user.login.email': '邮箱',
  'user.login.password': '密码',
  'user.login.login': '登录',
  'user.email.required': '请输入邮箱地址！',
  'user.email.wrong-format': '邮箱地址格式错误！',
  'user.userName.required': '请输入用户名!',
  'user.password.required': '请输入密码！',
  'user.email.placeholder': '邮箱',
  'user.login.success': '登录成功',
  'user.login.email-invalid': '不规范的邮箱地址',
  'user.forget-password': '忘记密码？',
  'user.activate.title': '餐厅激活',
  'user.activate': '激活',
  'user.activate.success': '成功激活餐厅',
  'user.gotoLogin': '前往登录',

  'user.login.inactive': '此餐厅暂未激活',

  'user.mobile.required': '请输入手机号码',
  'user.mobile.wrong-format': '手机号码格式错误',

  'user.login.identity': '登录身份',
};
